import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import "./OurSuccess.css";

const stats = [
  { number: 10, text: "Years Experience" },
  { number: 2000, text: "Number of Vendors Served" },
  { number: 1500, text: "Vendors Attrition" },
  { number: 3000, text: "Campaigned Designed" },
];

const OurSuccess = () => {
  const [counters, setCounters] = useState(stats.map(() => 0));
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing after animation triggers
        }
      },
      { threshold: 0.3, once: true } // Ensures it only runs once
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (isVisible) {
      const interval = setInterval(() => {
        setCounters((prevCounters) =>
          prevCounters.map((counter, index) => {
            const target = stats[index].number;
            const step = Math.ceil(target / 50); // Adjust this value for speed
            return counter < target ? Math.min(counter + step, target) : counter;
          })
        );
      }, 20); // Smaller interval = faster animation
      return () => clearInterval(interval);
    }
  }, [isVisible]);

  return (
    <section ref={sectionRef} className={`our-success-section ${isVisible ? "animate" : ""}`}>
      {/* Title */}
      <motion.h2
        className="section-title"
        initial={{ opacity: 0, y: -20 }}
        animate={isVisible ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 1 }}
        style={{marginBottom:'70px',fontSize:'20px'}}
      >
        <span>|</span> OUR SUCCESS <span>|</span>
      </motion.h2>

      {/* Stats */}
      <div className="stats-container">
        {stats.map((stat, index) => (
          <motion.div
            key={index}
            className="stat-box"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={isVisible ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 1, delay: index * 0.3 }}
          >
            <h3 className="counter">{counters[index]}+</h3>
            <p>{stat.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default OurSuccess;
